import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { HeaderButton } from 'src/app/angular-core/components/navigation/header-base/header-button/header-button.interface';
import { DialogAnimationService } from 'src/app/angular-core/services/dialog-animation.service';
import { DeviceSubscriptionOfferExt } from 'src/app/generated/CrossPoint.License.Server';
import { getLicensesLocalStorageAction } from 'src/app/store/actions/licenses.actions';
import { selectShoppingBasket } from 'src/app/store/selectors/licenses.selectors';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';
import { OrderLicensesComponent } from '../../pages/order-licenses/order-licenses.component';

@Component({
  selector: 'xpac-shopping-basket-button',
  templateUrl: './shopping-basket-button.component.html',
  styleUrls: ['./shopping-basket-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShoppingBasketButtonComponent implements OnInit, HeaderButton {

  private shoppingBasket: DeviceSubscriptionOfferExt[] = [];

  constructor(
    private store: Store<IRemoteXPACPortalState>,
    private dialog: DialogAnimationService,
    private cdr: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void {    
    this.store.select(selectShoppingBasket)
      .pipe(
        filter<DeviceSubscriptionOfferExt[]>(Boolean)
      )
      .subscribe((shoppingBasket: DeviceSubscriptionOfferExt[]) => {
        this.shoppingBasket = shoppingBasket;
        this.cdr.markForCheck();
      });
      
    this.store.dispatch(getLicensesLocalStorageAction());
  }

  public onShoppingBasketClick(): void {
    this.dialog.open(OrderLicensesComponent, {
      panelClass: 'my-full-screen-dialog',     
      animation: { to: "left" },
      disableClose: true
    });
  }

  public getNumberOfShoppingBasketItems(): number {
    return this.shoppingBasket.length;
  }
}
